import { render, staticRenderFns } from "./ForcarEnvioDialog.vue?vue&type=template&id=72ee4d97&scoped=true&lang=pug"
import script from "./ForcarEnvioDialog.vue?vue&type=script&lang=js"
export * from "./ForcarEnvioDialog.vue?vue&type=script&lang=js"
import style0 from "./ForcarEnvioDialog.vue?vue&type=style&index=0&id=72ee4d97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ee4d97",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
